import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const ThemeContext = createContext(null);

export function ThemeContextProvider({ children }) {
  const [themeMode, setThemeMode] = useState(() => {
    return localStorage.getItem('hugo-theme') || 'light';
  });

  const toggleTheme = useCallback(() => {
    setThemeMode((prev) => {
      const newMode = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem('hugo-theme', newMode);
      return newMode;
    });
  }, []);

  const value = useMemo(
    () => ({ themeMode, toggleTheme }),
    [themeMode, toggleTheme]
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export function useThemeMode() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within a ThemeContextProvider');
  }
  return context;
}

export default ThemeContext;
